import { UploadDocumentModel } from 'common/models/page-models/applicants/upload-document/upload-document-data.model';
import { FormDataService } from '../../base-data-services/form-data.service';
import { Injectable } from '@angular/core';
import { API_URL, API_METHODS, OperationType } from 'common/constants/sm-constants';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { environment } from 'src/environments/environment';
import { editInfo } from 'common/models/utility-models/utility-interface';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { ActivatedRoute, Params } from '@angular/router';
import { uploadDocument } from 'common/models/page-models/applicants/upload-document/upload-document-meta.model';

@Injectable({
  providedIn: 'root',
})
export class UploadDocumentDataService extends FormDataService<UploadDocumentModel> {
  constructor(
    http: SmApiService,
    protected override ss: SystemService,
    private aRoute: ActivatedRoute
  ) {
    super(API_URL.ApplicantUploadDocument, http, ss);
  }

  override getEditUrlAndMethod(id: any): editInfo {
    const edit = {
      url: environment.apiUrl + API_URL.getUploadedDocuments,
      method: API_METHODS.post,
    };
    return edit;
  }

  override getUpdatePayload(data) {
  
    // console.log(data);
    const payload = {
      token: data.transferData.replace(/ /g, '+')
    };

    return payload;
  }

  createInstance(): UploadDocumentModel {
    return new UploadDocumentModel();
  }

  override beforePostData(
    model: any,
    metamodel: any,
    dataModel: any
  ): Promise<UploadDocumentModel> {
    return new Promise<any>((resolve, reject) => {

      const uploaddocument = new uploadDocument();
      uploaddocument.applicant_id = dataModel.tokedata.applicant_id;
      uploaddocument.documentTypeId = metamodel.properties.uploadRemaining[0].documentTypeId;
      uploaddocument.uploadDocFile =  metamodel.properties.uploadedImage
      resolve(uploaddocument);
    });
  }

  override async postData(data, isFormData: boolean = true): Promise<any> {
    return await super.postData(this.convertFormData(data), isFormData);
  }


  override generateUrl(type: OperationType, paramKey?: any, extraKey?: any) {
    return environment.apiUrl + this.getAPI_URL();
  }

  getAuthStatus(): boolean {
    // const username = this.systemService.st(this.systemService.getlocalStorage('username'))
    if (
        // this.ss.getlocalStorage('profile') !== null &&
        // this.ss.getlocalStorage('profile') !== undefined &&
        this.ss.getlocalStorage('token') !== null &&
        this.ss.getlocalStorage('token') !== undefined
    ) {
        return true;
    } else {
        // console.log("else part")
        this.ss.navigateToUploadDoc();
        return false;
    }
}


override afterPostData(
  model: any,
  result?: any
): Promise<UploadDocumentModel> {
  return new Promise<UploadDocumentModel>((resolve, reject) => {
    // console.log(result, 'result');
    if(result.status === 'Success')
    {
      window.location.reload();
    }
    resolve(this.transformAPIData(model));
  });
}



}

export { FormDataService };
